import { render } from "./ArtistPrevList.vue?vue&type=template&id=9561c956"
import script from "./ArtistPrevList.vue?vue&type=script&lang=js"
export * from "./ArtistPrevList.vue?vue&type=script&lang=js"

import "./ArtistPrevList.vue?vue&type=style&index=0&id=9561c956&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__